import { render, staticRenderFns } from "./ClinicDoctorStat.vue?vue&type=template&id=5d5260d9&scoped=true"
import script from "./ClinicDoctorStat.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorStat.vue?vue&type=script&lang=js"
import style0 from "./ClinicDoctorStat.vue?vue&type=style&index=0&id=5d5260d9&prod&scoped=true&lang=css"
import style1 from "./ClinicDoctorStat.vue?vue&type=style&index=1&id=5d5260d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5260d9",
  null
  
)

export default component.exports